import React, { FC } from "react";
import styled from "@emotion/styled";
import { UserOutlined } from "@ant-design/icons";
import { graphDashboard, graphDashboard2, userAgent } from "assets/icons";
import { Col, Row } from "antd";
import { GetFactoryOverviewData } from "@/services/interface";
import { numberFormat, stringToCommaFormat } from "utils/nuberFormat";
import { parse } from "path";

interface ContentBodyProps {
  data: GetFactoryOverviewData | undefined;
}

const ContentBody:FC<ContentBodyProps> = ({data}) => {
  return (
    <Row gutter={[16,16]} style={{ marginTop: 20 }}  >
      <Col span={8} >
        <WrapperContentAgent>
          <WrapperIcon>
            <SpanIcon>{userAgent}</SpanIcon>
          </WrapperIcon>
          <WrapperTextContent>
            <TextAmount>{stringToCommaFormat(data?.agent ?? "0")}</TextAmount>
            <TextLabel>จำนวนตัวแทน</TextLabel>
          </WrapperTextContent>
        </WrapperContentAgent>
      </Col>
      <Col span={8} >
        <WrapperContentAgent>
          <WrapperIconGraph>
            <SpanIcon>{graphDashboard}</SpanIcon>
          </WrapperIconGraph>
          <WrapperTextContent>
            <TextAmount>฿{numberFormat(data?.profit ?? 0)}</TextAmount>
            <TextLabel>รายได้</TextLabel>
          </WrapperTextContent>
        </WrapperContentAgent>
      </Col>
      <Col span={8} >
        <WrapperContentAgent>
          <WrapperIconGraph2>
            <SpanIcon>{graphDashboard2}</SpanIcon>
          </WrapperIconGraph2>
          <WrapperTextContent>
            <TextAmount>{stringToCommaFormat(data?.order ?? "0")}</TextAmount>
            <TextLabel>คำสั่งซื้อ</TextLabel>
          </WrapperTextContent>
        </WrapperContentAgent>
      </Col>
    </Row>
  );
};

export default ContentBody;

const WrapperContentAgent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;
const WrapperIcon = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 8px;
  background-color: #dcddfc;
`;

const WrapperIconGraph = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 8px;
  background-color: #fcebca;
`;

const WrapperIconGraph2 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 8px;
  background-color: #d2f2fc;
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const WrapperTextContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: auto;
  border-radius: 0px;
  padding: 0px 0px 0px 10px;
`;

const TextAmount = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: #000000;
  background-color: #ffffff;
`;

const TextLabel = styled.p`
  font-size: 17px;
  font-weight: 400;
  color: #8c8c8c;
  background-color: #ffffff;

  @media (min-width: 1920px) {
    font-size: 16px;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    font-size: 15px;
  }
  @media (min-width: 481px) and (max-width: 767px) {
    font-size: 14px;
  }
  @media (max-width: 480px) {
    font-size: 12px;
  }
  @media (min-width: 481px) and (max-width: 991px) {
    font-size: 14px;
  }
`;
